'use client';
import { useState } from "react";

export default function SocialShareLink(url:any) {  
    const [showToastMsg, setShowToastMsg] =useState(false);
    const handleClick = () => {
        navigator.clipboard.writeText(url.url);
        setShowToastMsg(true);
        setTimeout(()=>setShowToastMsg(false),2000);
      };
    
    return(     
        <>
        <div className="copy_link_area">
            <button className="copy_link" type="button" onClick={handleClick}> <span className="copy_link_icon"></span> </button>
            {showToastMsg &&
                (
                    <div className="text_copied animate-fade-in-out">
                        Link Copied!
                    </div>
                )
            }

        </div>
        </>   
    )  
};